<div class="wallboardViewSlide" [attr.mid]="moduleKey" [ngStyle]="{ 'background-image': 'url(../Admin/ImageResizer.aspx?imgid=' + backgroundID + '&w=1920&h=1080)' }">
    <div class="wallboardViewSlideContentArea wallboardViewSlideContentAreaLight">
        <div style="box-sizing: border-box;">
            <div class="wvCurrentAgentStatesTitle d-flex w-100 text-center" style="border-radius:12px; font-size:26px" [ngStyle]="{ 'background-color': hasBackdrop ? 'rgba(0,0,0,0.4)' : 'transparent' }">
                <div class="summaryTitle txtOverflow w-50 h-100 text-left" style="flex:50">
                    <span class="d-inline-block mt-3">{{currentAgentStatesState?.SlideTitle}}</span>
                </div>

                <div class="d-inline-block w-50 h-100" style="flex:20">
                    <div cvLocalizedText langSection="Queue_Counter" langKey="Contacts_In_Queue">Calls in Queue</div>
                    <div>{{currentAgentStatesData?.CallsInQueueCount}}</div>
                </div>

                <div class="d-inline-block h-100" style="width:30%; flex:30">
                    <div cvLocalizedText langSection="Module" langKey="Longest_Call_In_Queue">Longest Call in Queue
                    </div>

                    <div>{{currentAgentStatesData?.LongestCallInQueueFormatted}}</div>
                </div>

                <div class="d-inline-block h-100" style="width:20%; flex:20">
                    <div cvLocalizedText langSection="Module" langKey="Total_Agents">Total Agents</div>
                    <div>{{currentAgentStatesData?.TotalCount}}</div>
                </div>
            </div>
        </div>

        <div class="clearBoth"></div>

        <div class="wvCurrentAgentStatesTableData">
            <!-- Inbound / Outbound Contact -->
            <div class="wvCurrentAgentStatesColumn" style="display:grid; flex:2; max-width:40%; grid-template-columns:30px auto auto 140px"
                 [ngStyle]="{ 'background-color': hasBackdrop ? 'rgba(0,0,0,0.4)' : 'transparent' }">
                <div class="wvCurrentAgentStatesColumnTitle" style="min-height:90px; max-height:180px; grid-row-start:1; grid-column:span 4">
                    <div>
                        <span cvLocalizedText langSection="Wallboard_Management" langKey="Inbound">Inbound</span>
                        <!--Inbound-->
                        <span class="wvCurrentAgentStatesStateBox d-inline-block mb-3" style="padding:0px 10px; background-color:#7C52BF">{{currentAgentStatesData?.InboundCount}}</span>
                    </div>

                    <div>
                        <span cvLocalizedText langSection="Wallboard_Management" langKey="Outbound">Outbound</span>
                        <!--Outbound-->
                        <span class="wvCurrentAgentStatesStateBox d-inline-block mb-3" style="padding:0px 10px; background-color:#E4B321">{{currentAgentStatesData?.OutboundCount}}</span>
                    </div>
                </div>

                <ng-container *ngFor="let item of filledOnCall; let $index = index">
                    <div class="wvCurrentAgentStatesStateIndicator"
                         [ngStyle]="{ 'background-color': item.callDirection == 'Inbound' ? '#7C52BF' : (item.callDirection != '' ? '#E4B321' : 'transparent'), 'grid-row-start': $index + 2 }">
                    </div>

                    <div class="wvCurrentAgentStatesGridCell wvCASEllip" [ngStyle]="{ 'grid-row-start': $index + 2 }">{{item.groupName}}</div>
                    <div class="wvCurrentAgentStatesGridCell wvCASEllip" [ngStyle]="{ 'grid-row-start': $index + 2 }">{{item.stateName}}</div>
                    <div class="wvCurrentAgentStatesGridCell wvTimeCell" [ngStyle]="{ 'grid-row-start': $index + 2 }">{{item.stateTime}}</div>
                </ng-container>
            </div>

            <!-- Unavailable -->
            <div class="wvCurrentAgentStatesColumn" style="display:grid; flex:1.5; max-width:35%; grid-template-columns:auto auto 140px" [ngStyle]="{'background-color': hasBackdrop ? 'rgba(0,0,0,0.4)' : 'transparent'}">
                <div class="wvCurrentAgentStatesColumnTitle" style="min-height:45px; max-height:90px; grid-row-start:1; grid-column:span 3">
                    <span cvLocalizedText langSection="Wallboard_Management" langKey="Unavailable">Unavailable</span>
                    <span class="wvCurrentAgentStatesStateBox d-inline-block mb-3" style="padding:0px 10px; background-color: #BD2026">{{currentAgentStatesData?.UnavailableCount}}</span>
                </div>

                <ng-container *ngFor="let item of filledUnavailable; let $index = index">
                    <div class="wvCurrentAgentStatesGridCell wvCASEllip" [ngStyle]="{ 'grid-row-start': $index + 2 }">{{item.groupName}}</div>

                    <div class="wvCurrentAgentStatesGridCell wvCASEllip p-2" style="border-radius:12px"
                         [ngStyle]="{ 'background-color': item.stateName == '' ? 'transparent' : (item.isACW ? '#F24813' : '#BD2026'), 'grid-row-start': $index + 2 }">
                        {{item.stateName}}
                    </div>

                    <div class="wvCurrentAgentStatesGridCell wvTimeCell" [ngStyle]="{ 'grid-row-start': $index + 2 }">{{item.stateTime}}</div>
                </ng-container>
            </div>

            <!-- Available -->
            <div class="wvCurrentAgentStatesColumn" style="display:grid; flex:1; max-width:25%; grid-template-columns:auto 140px" [ngStyle]="{ 'background-color': hasBackdrop ? 'rgba(0,0,0,0.4)' : 'transparent' }">
                <div class="wvCurrentAgentStatesColumnTitle" style="min-height:45px; max-height:90px; grid-row-start:1; grid-column:span 3">
                    <span cvLocalizedText langSection="Wallboard_Management" langKey="Available">Available</span>
                    <span class="wvCurrentAgentStatesStateBox d-inline-block mb-3" style="padding: 0px 10px; background-color: #3D9649">{{currentAgentStatesData?.AvailableCount}}</span>
                </div>

                <ng-container *ngFor="let item of filledAvailable; let $index = index">
                    <div class="wvCurrentAgentStatesGridCell wvCASEllip" [ngStyle]="{ 'grid-row-start': $index + 2 }">{{item.groupName}}</div>
                    <div class="wvCurrentAgentStatesGridCell wvTimeCell" [ngStyle]="{ 'grid-row-start': $index + 2 }">{{item.stateTime}}</div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
